import FinCategoriesPage from '@playground/features/dictionary/FinCategoriesPage'
import { createFileRoute } from '@tanstack/react-router'

export const Route = createFileRoute(
  '/_app/_superAdmin/dictionary/fin-categories'
)({
  component: FinCategoriesPage,
})
